export default "__VITE_ASSET__f8139ae2__"